import Gooey, { mount, Component, Dyn, dynSet } from '@srhazi/gooey';

export const BooleanInput: Component<{
    value: Dyn<boolean>;
    id?: Dyn<string>;
}> = ({ value, id }) => {
    return (
        <input
            on:input={(e, el) => {
                dynSet(value, el.checked);
            }}
            checked={value}
            id={id}
            type="checkbox"
        />
    );
};
